import React from 'react';
import { FiUsers, FiMail, FiBriefcase, FiCheckCircle } from 'react-icons/fi';

const Dashboard = () => {
  return (
    <div className="dashboard-content">
      <h2>Welcome to the Admin Dashboard!</h2>

      <div className="dashboard-summary-cards">
        <div className="card">
          <div className="card-icon"><FiMail size={30} /></div>
          <div className="card-info">
            <h3>New Messages</h3>
            <p className="card-value">15</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon"><FiBriefcase size={30} /></div>
          <div className="card-info">
            <h3>Active Jobs</h3>
            <p className="card-value">7</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon"><FiUsers size={30} /></div>
          <div className="card-info">
            <h3>New Applications</h3>
            <p className="card-value">22</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon"><FiCheckCircle size={30} /></div>
          <div className="card-info">
            <h3>Tasks Completed</h3>
            <p className="card-value">120</p>
          </div>
        </div>
      </div>

      <div className="dashboard-section">
        <h3>Recent Activity</h3>
        <ul>
          <li>New message from John Doe on Contact Us.</li>
          <li>Job 'React Developer' posted.</li>
          <li>Application received for 'UI/UX Designer'.</li>
          <li>Status of message #101 changed to 'Assigned'.</li>
        </ul>
      </div>

      <style jsx>{`
        .dashboard-content {
          padding: 20px; /* cite: 441 */
          background-color: var(--bg);
          color: var(--text);
          border-radius: 8px;
        }
        h2 {
          color: #2a4e85; /* cite: 442 */
          margin-bottom: 20px;
          font-size: 28px;
        }
        p {
          color: var(--subtext); /* cite: 443 */
          margin-bottom: 30px;
        }
        .dashboard-summary-cards {
          display: grid; /* cite: 444 */
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-bottom: 40px;
        }
        .card {
          background-color: var(--card); /* cite: 445 */
          padding: 25px;
          border-radius: 10px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
          display: flex;
          align-items: center;
          gap: 20px; /* cite: 446 */
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          border: 1px solid var(--border); /* cite: 447 */
        }
        .card:hover {
            transform: translateY(-5px); /* cite: 448 */
            box-shadow: 0 8px 15px rgba(0, 0, 0, 0.12);
        }
        .card-icon {
          background-color: #0056b3; /* cite: 449 */
          color: white;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0; /* cite: 450 */
        }
        .card-info h3 {
          margin: 0 0 5px 0; /* cite: 451 */
          font-size: 18px;
          color: var(--text);
        }
        .card-value {
          font-size: 28px; /* cite: 452 */
          font-weight: bold;
          color: #0056b3;
          margin: 0;
        }
        .dashboard-section {
          background-color: var(--card); /* cite: 453 */
          padding: 25px;
          border-radius: 10px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
          border: 1px solid var(--border); /* cite: 454 */
        }
        .dashboard-section h3 {
          color: var(--text); /* cite: 455 */
          font-size: 22px;
          margin-top: 0;
          margin-bottom: 15px;
          border-bottom: 1px solid var(--border);
          padding-bottom: 10px; /* cite: 456 */
        }
        .dashboard-section ul {
          list-style: none; /* cite: 457 */
          padding: 0;
          margin: 0;
        }
        .dashboard-section li {
          padding: 10px 0; /* cite: 458 */
          border-bottom: 1px dashed var(--border);
          color: var(--subtext);
          font-size: 15px;
        }
        .dashboard-section li:last-child {
          border-bottom: none; /* cite: 459 */
        }

        @media (max-width: 768px) {
            .dashboard-summary-cards {
                grid-template-columns: 1fr; /* cite: 460 */
            }
        }
      `}</style>
    </div>
  );
};

export default Dashboard;